import { SharedModule } from 'libs/shared/src/lib/shared.module';
import { SpinnersModule } from './../../../spinners/src/lib/spinners.module';
import { EffectsModule } from '@ngrx/effects';
import { EpimsDashboardNavModule } from '@cradua/epims-dashboard-nav';
import { AngularMaterialModule } from '@cradua/material';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Route } from '@angular/router';
import { ReferenceContainerComponent } from './containers/reference-container/reference-container.component';
import { RefencesRoutingModule } from './references-routing.module';
import { StoreModule } from '@ngrx/store';
import * as fromCountry from './states/+country/country.reducer';
import { CountryEffects } from './states/+country/country.effects';
import { HttpClientModule } from '@angular/common/http';
import { CountryFacade } from './states/+country/country.facade';
import { ReactiveFormsModule } from '@angular/forms';
import { StateFacade } from './states/+state/state.facade';
import { LgaFacade } from './states/+lga/lga.facade';
import { StateEffects } from './states/+state/state.effects';
import { LgaEffects } from './states/+lga/lga.effects';
import { ScholarshipCategoryEffects } from './states/+scholarshipcategory/scholarshipcategory.effects';
import { ScholarshipTypeEffects } from './states/+scholarshiptype/scholarshiptype.effects';
import { ScholarshipSessionEffects } from './states/+scholarshipsession/scholarshipsession.effects';
import { ScholarshipAwardDurationEffects } from './states/+scholarshipawardduration/scholarshipawardduration.effects';
import { CommunityEffects } from './states/+community/community.effects';
import { CourseOfStudyEffects } from './states/+courseofstudy/courseofstudy.effects';
import { ScholarshipTypeFacade } from './states/+scholarshiptype/scholarshiptype.facade';
import { ScholarshipCategoryFacade } from './states/+scholarshipcategory/scholarshipcategory.facade';
import { ScholarshipSessionFacade } from './states/+scholarshipsession/scholarshipsession.facade';
import { CommunityFacade } from './states/+community/community.facade';
import { CourseOfStudyFacade } from './states/+courseofstudy/courseofstudy.facade';
import { ScholarshipAwardDurationFacade } from './states/+scholarshipawardduration/scholarshipawardduration.facade';
import { GenderEffects } from './states/+gender/gender.effects';
import { GenderFacade } from './states/+gender/gender.facade';
import { EpimsBankEffects } from './states/+bank/bank.effects';
import { EpimsBankFacade } from './states/+bank/bank.facade';
import { EpimsBankDetailEffects } from './states/+bankDetail/bank-detail.effects';
import { EpimsBankDetailFacade } from './states/+bankDetail/bank-detail.facade';
import { CurrencyFacade } from './states/+currency/currency.facade';
import { CurrencyEffects } from './states/+currency/currency.effects';
import { ProjectCategoryEffects } from './states/+project-category/project-category.effects';
import { ProjectTypeEffects } from './states/+project-type/project-type.effects';
import { ClusterEffects } from './states/+cluster/cluster.effects';
import { ClusterCommunityEffects } from './states/+cluster-community/cluster-community.effects';
import { OilBlockEffects } from './states/+oil-block/oil-block.effects';
import { OilFieldEffects } from './states/+oil-field/oil-field.effects';
import { DocumentCategoryEffects } from './states/+document-category/document-category.effects';
import { DocumentSubCategoryEffects } from './states/+document-sub-category/document-sub-category.effects';
import { OilBlockFacade } from './states/+oil-block/oil-block.facade';
import { DocumentCategoryFacade } from './states/+document-category/document-category.facade';
import { DocumentSubCategoryFacade } from './states/+document-sub-category/document-sub-category.facade';
import { OilFieldFacade } from './states/+oil-field/oil-field.facade';
import { ClusterCommunityFacade } from './states/+cluster-community/cluster-community.facade';
import { ClusterFacade } from './states/+cluster/cluster.facade';
import { ProjectTypeFacade } from './states/+project-type/project-type.facade';
import { ProjectCategoryFacade } from './states/+project-category/project-category.facade';
import { ProjectReferenceContainerComponent } from './containers/project-reference-container/project-reference-container.component';
import { GeneralReferenceContainerComponent } from './containers/general-reference-container/general-reference-container.component';
import { CorrespondenceReferenceComponent } from './containers/correspondence-reference/correspondence-reference.component';
import { CorrespondenceActionPartyEffects } from './states/+action-party/action-party.effects';
import { CorrespondenceFunctionEffects } from './states/+function/function.effects';
import { CorrespondenceCompanyEffects } from './states/+company/company.effects';
import { CorrespondenceTeamEffects } from './states/+team/team.effects';
import { CorrespondenceRequestCategoryEffects } from './states/+request-category/request-category.effects';
import { CorrespondenceIssuedCategoryEffects } from './states/+issued-category/issued-category.effects';
import { CorrespondenceActionPartyFacade } from './states/+action-party/action-party.facade';
import { CorrespondenceCompanyFacade } from './states/+company/company.facade';
import { CorrespondenceTeamFacade } from './states/+team/team.facade';
import { CorrespondenceFunctionFacade } from './states/+function/function.facade';
import { CorrespondenceRequestCategoryFacade } from './states/+request-category/request-category.facade';
import { CorrespondenceIssuedCategoryFacade } from './states/+issued-category/issued-category.facade';
import { GroupContainerComponent } from './containers/group-container/group-container.component';
import { EpimsReferenceSpinnerComponent } from 'libs/spinners/src/lib/components/epims-reference-spinner/epims-reference-spinner.component';
import { AccountablefunctionContainerComponent } from './containers/accountablefunction-container/accountablefunction-container.component';
import { AccountablefunctionComponent } from './component/accountablefunction/accountablefunction.component';
import { GroupComponent } from './component/group/group.component';
import { PaymentstatusComponent } from './component/paymentstatus/paymentstatus.component';
import { PaymentstatusContainerComponent } from './containers/paymentstatus-container/paymentstatus-container.component';
import { OwnershiptypeComponent } from './component/ownershiptype/ownershiptype.component';
import { OwnershiptypeContainerComponent } from './containers/ownershiptype-container/ownershiptype-container.component';
import { ClaimTypeComponent } from './component/claimtype/claimtype.component';
import { TerrainComponent } from './component/terrain/terrain.component';
import { SubGroupComponent } from './component/subgroup/subgroup.component';
import { SubSubGroupComponent } from './component/subsubgroup/subsubgroup.component';
import { SubsubgrouptypeComponent } from './component/subsubgrouptype/subsubgrouptype.component';
import { SubsubgrouptypecategoryComponent } from './component/subsubgrouptypecategory/subsubgrouptypecategory.component';
import { TerrainContainerComponent } from './containers/terrain-container/terrain-container.component';
import { ClaimTypeContainerComponent } from './containers/claimtype-container/claimtype-container.component';
import { SubGroupContainerComponent } from './containers/subgroup-container/subgroup-container.component';
import { SubSubGroupContainerComponent } from './containers/subsubgroup-container/subsubgroup-container.component';
import { SubsubgrouptypeContainerComponent } from './containers/subsubgrouptype-container/subsubgrouptype-container.component';
import { SubsubgrouptypecategoryContainerComponent } from './containers/subsubgrouptypecategory-container/subsubgrouptypecategory-container.component';
import { CompanyComponent } from './component/company/company.component';
import { FunctionComponent } from './component/function/function.component';
import { CompanyContainerComponent } from './containers/company-container/company-container.component';
import { FunctionContainerComponent } from './containers/function-container/function-container.component';
import { DivestmentStatusComponent } from './component/divestmentstatus/divestmentstatus.component';
import { EncroachmentStatusComponent } from './component/encroachmentstatus/encroachmentstatus.component';
import { EncroachmentTypeComponent } from './component/encroachmenttype/encroachmenttype.component';
import { EncroachmentTypeContainerComponent } from './containers/encroachmenttype-container/encroachmenttype-container.component';
import { EncroachmentStatusContainerComponent } from './containers/encroachmentstatus-container/encroachmentstatus-container.component';
import { DivestmentStatusContainerComponent } from './containers/divestmentstatus-container/divestmentstatus-container.component';
import { TitleComponent } from './component/title/title.component';
import { TitleContainerComponent } from './containers/title-container/title-container.component';
import { DocumentTypeContainerComponent } from './containers/documenttype-container/documenttype-container.component';
import { DocumentTypeComponent } from './component/documenttype/documenttype.component';
import { BankComponent } from './component/bank/bank.component';
import { BankContainerComponent } from './containers/bank-container/bank-container.component';
import { DivisionContainerComponent } from './containers/division-container/division-container.component';
import { DivisionComponent } from './component/division/division.component';
import { ContinentComponent } from './component/continent/continent.component';
import { ContinentContainerComponent } from './containers/continent-container/continent-container.component';
import { FileLocationContainerComponent } from './containers/file-location-container/file-location-container.component';
import { FileLocationComponent } from './component/file-location/file-location.component';
import { GeoDatumComponent } from './component/geo-datum/geo-datum.component';
import { GeoDatumContainerComponent } from './containers/geo-datum-container/geo-datum-container.component';
import { CountryContainerComponent } from './containers/country-container/country-container.component';
import { CountryComponent } from './component/country/country.component';
import { StateComponent } from './component/state/state.component';
import { StateContainerComponent } from './containers/state-container/state-container.component';
import { LgaContainerComponent } from './containers/lga-container/lga-container.component';
import { LgaComponent } from './component/lga/lga.component';
import { CommunityComponent } from './component/community/community.component';
import { CommunityContainerComponent } from './containers/community-container/community-container.component';
import { MeasureComponent } from './component/measure/measure.component';
import { PurposeComponent } from './component/purpose/purpose.component';
import { CurrencyComponent } from './component/currency/currency.component';
import { BankingStatusComponent } from './component/banking-status/banking-status.component';
import { LandUseStatusComponent } from './component/land-use-status/land-use-status.component';
import { RightHeldComponent } from './component/right-held/right-held.component';
import { MeasureContainerComponent } from './containers/measure-container/measure-container.component';
import { PurposeContainerComponent } from './containers/purpose-container/purpose-container.component';
import { CurrencyContainerComponent } from './containers/currency-container/currency-container.component';
import { BankingStatusContainerComponent } from './containers/banking-status-container/banking-status-container.component';
import { LandUseStatusContainerComponent } from './containers/land-use-status-container/land-use-status-container.component';
import { RightHeldContainerComponent } from './containers/right-held-container/right-held-container.component';

import { CategoryComponent } from './component/category/category.component';
import { AppConfigurationComponent } from './component/app-configuration/app-configuration.component';
import { CategoryContainerComponent } from './containers/category-container/category-container.component';
import { MeasuringFactorComponent } from './component/measuring-factor/measuring-factor.component';
import { MeasuringFactorContainerComponent } from './containers/measuring-factor-container/measuring-factor-container.component';
import { AppConfigurationContainerComponent } from './containers/app-configuration-container/app-configuration-container.component';
import { CabinetshelfrefComponent } from './component/cabinetshelfref/cabinetshelfref.component';
import { CabinetshelfrefContainerComponent } from './containers/cabinetshelfref-container/cabinetshelfref-container.component';
import { DocumentTypeCodeContainerComponent } from './containers/documenttypecode-container/documenttypecode-container.component';
import { DocumentTypeCodeComponent } from './component/documenttypecode/documenttypecode.component';
import { RackettrayrefComponent } from './component/rackettrayref/rackettrayref.component';
import { RackettrayrefContainerComponent } from './containers/rackettrayref-container/rackettrayref-container.component';
import { SecurityClassificationComponent } from './component/security-classification/security-classification.component';
import { SecurityClassificationContainerComponent } from './containers/security-classification-container/security-classification-container.component';
import { PipelineLicenseCategoryComponent } from './component/pipeline-license-category/pipeline-license-category.component';
import { HierarchyComponent } from './component/hierarchy/hierarchy.component';
import { PipelineLicenseStageComponent } from './component/pipeline-license-stage/pipeline-license-stage.component';
import { PipelineLicenseStakeholderComponent } from './component/pipeline-license-stakeholder/pipeline-license-stakeholder.component';
import { HierarchyContainerComponent } from './containers/hierarchy-container/hierarchy-container.component';
import { PipelineLicenseCategoryContainerComponent } from './containers/pipeline-license-category-container/pipeline-license-category-container.component';
import { PipelineLicenseStageContainerComponent } from './containers/pipeline-license-stage-container/pipeline-license-stage-container.component';
import { PipelineLicenseStakeholderContainerComponent } from './containers/pipeline-license-stakeholder-container/pipeline-license-stakeholder-container.component';
import { StakeholderrepComponent } from './component/stakeholderrep/stakeholderrep.component';
import { StakeholderrepContainerComponent } from './containers/stakeholderrep-container/stakeholderrep-container.component';
import { FilterReferencePipe } from './filter-reference.pipe';
import { IncidentSubCategoryContainerComponent } from './containers/incident-sub-category-container/incident-sub-category-container.component';
import { IncidentSubCategoryComponent } from './component/incident-sub-category/incident-sub-category.component';
import { IncidentQuantumComponent } from './component/incident-quantum/incident-quantum.component';
import { IncidentQuantumContainerComponent } from './containers/incident-quantum-container/incident-quantum-container.component';
import { RequesttypeContainerComponent } from './containers/requesttype-container/requesttype-container.component';
import { RequesttypeComponent } from './component/requesttype/requesttype.component';
import { AssetstatusComponent } from './component/assetstatus/assetstatus.component';
import { AssetstatusContainerComponent } from './containers/assetstatus-container/assetstatus-container.component';
import { LicenceStatusComponent } from './component/licence-status/licence-status.component';
import { LicenceStatusContainerComponent } from './containers/licence-status-container/licence-status-container.component';
import { DamageStatusComponent } from './component/damage-status/damage-status.component';
import { DamageStatusContainerComponent } from './containers/damage-status-container/damage-status-container.component';
import { CofOStatusComponent } from './component/cof-ostatus/cof-ostatus.component';
import { CofOStatusContainerComponent } from './containers/cof-ostatus-container/cof-ostatus-container.component';
import { CounselTypeComponent } from './component/counsel-type/counsel-type.component';
import { CounselTypeContainerComponent } from './containers/counsel-type-container/counsel-type-container.component';
import { AccessRightComponent } from './component/access-right/access-right.component';
import { AccessRightContainerComponent } from './containers/access-right-container/access-right-container.component';
import { LessorRepTypeComponent } from './component/lessor-rep-type/lessor-rep-type.component';
import { LessorRepTypeContainerComponent } from './containers/lessor-rep-type-container/lessor-rep-type-container.component';
import { QuantumComponent } from './component/quantum/quantum.component';
import { QuantumContainerComponent } from './containers/quantum-container/quantum-container.component';
import { PoleComponent } from './component/pole/pole.component';
import { PoleContainerComponent } from './containers/pole-container/pole-container.component';
import { RateStatusComponent } from './component/rate-status/rate-status.component';
import { RateStatusContainerComponent } from './containers/rate-status-container/rate-status-container.component';
import { YearOfSuitContainerComponent } from './containers/year-of-suit-container/year-of-suit-container.component';
import { YearOfSuitComponent } from './component/year-of-suit/year-of-suit.component';
import { DocumentCategoryContainerComponent } from './containers/document-category-container/document-category-container.component';
import { DocumentCategoryComponent } from './component/document-category/document-category.component';
import { ObligationPeriodComponent } from './component/ObligationPeriod/obligationperiod.component';
import { ObligationPeriodContainerComponent } from './containers/obligationperiod-container/obligationperiod-container.component';
import { RequestSubCategoryComponent } from './component/requestsubcategory/requestsubcategory.component';
import { RequestSubCategoryContainerComponent } from './containers/requestsubcategory-container/requestsubcategory-container.component';
import { RackTrayRefComponent } from './component/racktrayref/racktrayref.component';
import { RackTrayRefContainerComponent } from './containers/racktrayref-container/racktrayref-container.component';
import { AcquisitiontypeComponent } from './component/acquisitiontype/acquisitiontype.component';
import { AcquisitiontypeContainerComponent } from './containers/acquisitiontype-container/acquisitiontype-container.component';
import { ActivityStatusComponent } from './component/activity-status/activity-status.component';
import { ActivityStatusContainerComponent } from './containers/activity-status-container/activity-status-container.component';
import { AddressTypeTblComponent } from './component/address-type-tbl/address-type-tbl.component';
import { AddressTypeTblContainerComponent } from './containers/address-type-tbl-container/address-type-tbl-container.component';
import { BatchComponent } from './component/batch/batch.component';
import { BatchContainerComponent } from './containers/batch-container/batch-container.component';
import { CabinetShelfRefComponent } from './component/cabinet-shelf-ref/cabinet-shelf-ref.component';
import { CabinetShelfRefContainerComponent } from './containers/cabinet-shelf-ref-container/cabinet-shelf-ref-container.component';
import { CleanUpStatusComponent } from './component/cleanupstatus/cleanupstatus.component';
import { CleanUpStatusContainerComponent } from './containers/cleanupstatus-container/cleanupstatus-container.component';
import { DamageListComponent } from './component/damage-list/damage-list.component';
import { DamageListContainerComponent } from './containers/damage-list-container/damage-list-container.component';
import { DeliveryTypeComponent } from './component/delivery-type/delivery-type.component';
import { DeliveryTypeContainerComponent } from './containers/delivery-type-container/delivery-type-container.component';
import { ExpirationStatusComponent } from './component/expirationstatus/expirationstatus.component';
import { ExpirationStatusContainerComponent } from './containers/expirationstatus-container/expirationstatus-container.component';
import { FacilityAssetComponent } from './component/facilityasset/facilityasset.component';
import { FacilityAssetContainerComponent } from './containers/facilityasset-container/facilityasset-container.component';
import { IncidentCategoryComponent } from './component/incidentcategory/incidentcategory.component';
import { IncidentCategoryContainerComponent } from './containers/incidentcategory-container/incidentcategory-container.component';
import { IPStatusComponent } from './component/ipstatus/ipstatus.component';
import { IPStatusContainerComponent } from './containers/ipstatus-container/ipstatus-container.component';
import { IssuedCategoryComponent } from './component/issuedcategory/issuedcategory.component';
import { IssuedCategoryContainerComponent } from './containers/issuedcategory-container/issuedcategory-container.component';
import { ItemTypeComponent } from './component/itemtype/itemtype.component';
import { ItemTypeContainerComponent } from './containers/itemtype-container/itemtype-container.component';
import { LorpContainerComponent } from './containers/lorp-container/lorp-container.component';
import { LorpComponent } from './component/lorp/lorp.component';
import { NetworkComponent } from './component/network/network.component';
import { NetworkContainerComponent } from './containers/network-container/network-container.component';
import { LeaseExpirationContainerComponent } from './containers/lease-expiration-container/lease-expiration-container.component';
import { LeaseExpirationComponent } from './component/lease-expiration/lease-expiration.component';
import { CorrespondencecompanyContainerComponent } from './containers/correspondencecompany-container/correspondencecompany-container.component';
import { CorrespondencecompanyComponent } from './component/correspondencecompany/correspondencecompany.component';
import { CorrespondenceteamComponent } from './component/correspondenceteam/correspondenceteam.component';
import { CorrespondenceteamContainerComponent } from './containers/correspondenceteam-container/correspondenceteam-container.component';
import { LandprefixComponent } from './component/landprefix/landprefix.component';
import { LandprefixContainerComponent } from './containers/landprefix-container/landprefix-container.component';
import { LossOfUseItemsComponent } from './component/loss-of-use-items/loss-of-use-items.component';
import { LossOfUseItemsContainerComponent } from './containers/loss-of-use-items-container/loss-of-use-items-container.component';
import { CorrespondenceactionpartyComponent } from './component/correspondenceactionparty/correspondenceactionparty.component';
import { CorrespondenceactionpartyContainerComponent } from './containers/correspondenceactionparty-container/correspondenceactionparty-container.component';
import { CompanyFunctionContainerComponent } from './containers/companyfunction-container/companyfunction-container.component';
import { CompanyFunctionComponent } from './component/companyfunction/companyfunction.component';
import { NumberofapprovalContainerComponent } from './containers/numberofapproval-container/numberofapproval-container.component';
import { ApprovalLevelContainerComponent } from './containers/approval-level-container/approval-level-container.component';
import {  ApprovalLevelComponent } from './component/approval-level/approval-level.component';
import { NumberofapprovalComponent } from './component/numberofapproval/numberofapproval.component';
import { SeismicClaimTypeComponent } from './component/seismic-claim-type/seismic-claim-type.component';
import { SeismicCommunityComponent } from './component/seismic-community/seismic-community.component';
import { SeismicCrewComponent } from './component/seismic-crew/seismic-crew.component';
import { SeismicClaimTypeContainerComponent } from './containers/seismic-claim-type-container/seismic-claim-type-container.component';
import { SeismicCommunityContainerComponent } from './containers/seismic-community-container/seismic-community-container.component';
import { SeismicCrewContainerComponent } from './containers/seismic-crew-container/seismic-crew-container.component';
import { SeismicDamageListContainerComponent } from './containers/seismicdamagelist-container/seismicdamagelist-container.component';
import { SeismicDivisionContainerComponent } from './containers/seismicdivision-container/seismicdivision-container.component';
import { SeismicPartyContainerComponent } from './containers/seismicparty-container/seismicparty-container.component';
import { SeismicSwathNoContainerComponent } from './containers/seismicswathno-container/seismicswathno-container.component';
import { SeismicDamageListComponent } from './component/seismicdamagelist/seismicdamagelist.component';
import { SeismicDivisionComponent } from './component/seismicdivision/seismicdivision.component';
import { SeismicPartyComponent } from './component/seismicparty/seismicparty.component';
import { SeismicSwathNoComponent } from './component/seismicswathno/seismicswathno.component';
import { SeismicCurrencyContainerComponent } from './containers/seismic-currency-container/seismic-currency-container.component';
import { SeismicLineTypeContainerComponent } from './containers/seismic-line-type-container/seismic-line-type-container.component';
import { SeismicProgramContainerComponent } from './containers/seismic-program-container/seismic-program-container.component';
import { SeismicOMLContainerComponent } from './containers/seismic-omlcontainer/seismic-omlcontainer.component';
import { SeismicProgramComponent } from './component/seismic-program/seismic-program.component';
import { SeismicOMLComponent } from './component/seismic-oml/seismic-oml.component';
import { SeismicLineTypeComponent } from './component/seismic-line-type/seismic-line-type.component';
import { SeismicCurrencyComponent } from './component/seismic-currency/seismic-currency.component';
import { PipelinegradeContainerComponent } from './containers/pipelinegrade-container/pipelinegrade-container.component';
import { PipelineassetlocationContainerComponent } from './containers/pipelineassetlocation-container/pipelineassetlocation-container.component';
import { PipelinegradeComponent } from './component/pipelinegrade/pipelinegrade.component';
import { PipelineAssetLocationComponent } from './component/pipeline-asset-location/pipeline-asset-location.component';
import { PartyContainerComponent } from './containers/party-container/party-container.component';
import { PartyComponent } from './component/party/party.component';
import { IncidenteventtypeContainerComponent } from './containers/incidenteventtype-container/incidenteventtype-container.component';
import { IncidentriskareaContainerComponent } from './containers/incidentriskarea-container/incidentriskarea-container.component';
import { IncidenttabsContainerComponent } from './containers/incidenttabs-container/incidenttabs-container.component';
import { IncidenttabsineventContainerComponent } from './containers/incidenttabsinevent-container/incidenttabsinevent-container.component';
import { IncidentEventTypeComponent } from './component/incident-event-type/incident-event-type.component';
import { IncidentRiskAreaComponent } from './component/incident-risk-area/incident-risk-area.component';
import { IncidentTabsComponent } from './component/incident-tabs/incident-tabs.component';
import { IncidentTabsInEventComponent } from './component/incident-tabs-in-event/incident-tabs-in-event.component';
import { IncidentaboutContainerComponent } from './containers/incidentabout-container/incidentabout-container.component';
import { IncidentownersmappingContainerComponent } from './containers/incidentownersmapping-container/incidentownersmapping-container.component';
import { IncidentAboutComponent } from './component/incident-about/incident-about.component';
import { IncidentOwnersMappingComponent } from './component/incident-owners-mapping/incident-owners-mapping.component';
import { ReportReferenceComponent } from './containers/report-reference/report-reference.component';




export const epimsReferencesRoutes: Route[] = [];

@NgModule({
  imports: [

CommonModule,
    RouterModule,
    RefencesRoutingModule,
    AngularMaterialModule,
    EpimsDashboardNavModule,
    HttpClientModule,
    SpinnersModule,
    SharedModule,
    ReactiveFormsModule,

    StoreModule.forFeature(
      fromCountry.COUNTRY_FEATURE_KEY,
      fromCountry.reducer
    ),
    EffectsModule.forFeature([
      CountryEffects,
      StateEffects,
      LgaEffects,
      ScholarshipTypeEffects,
      ScholarshipCategoryEffects,
      ScholarshipSessionEffects,
      ScholarshipAwardDurationEffects,
      CommunityEffects,
      CourseOfStudyEffects,
      GenderEffects,
      EpimsBankEffects,
      EpimsBankDetailEffects,
      CurrencyEffects,
      ProjectCategoryEffects,
      ProjectTypeEffects,
      ClusterEffects,
      ClusterCommunityEffects,
      OilBlockEffects,
      OilFieldEffects,
      DocumentCategoryEffects,
      DocumentSubCategoryEffects,
      CorrespondenceActionPartyEffects,
      CorrespondenceFunctionEffects,
      CorrespondenceCompanyEffects,
      CorrespondenceTeamEffects,
      CorrespondenceRequestCategoryEffects,
      CorrespondenceIssuedCategoryEffects,
    ]),
  ],
  declarations: [
    NumberofapprovalContainerComponent,
ApprovalLevelContainerComponent,
    ReferenceContainerComponent,
    ProjectReferenceContainerComponent,
    GeneralReferenceContainerComponent,
    CorrespondenceReferenceComponent,
    GroupComponent,
    GroupContainerComponent,
    AccountablefunctionContainerComponent,
    AccountablefunctionComponent,
    PaymentstatusComponent,
    PaymentstatusContainerComponent,
    OwnershiptypeComponent,
    OwnershiptypeContainerComponent,
    ClaimTypeComponent,
    TerrainComponent,
    SubGroupComponent,
    SubSubGroupComponent,
    SubsubgrouptypeComponent,
    SubsubgrouptypecategoryComponent,
    TerrainContainerComponent,
    ClaimTypeContainerComponent,
    SubGroupContainerComponent,
    SubSubGroupContainerComponent,
    SubsubgrouptypeContainerComponent,
    SubsubgrouptypecategoryContainerComponent,
    CompanyComponent,
    CompanyContainerComponent,
    DivestmentStatusComponent,
    EncroachmentStatusComponent,
    EncroachmentTypeComponent,
    EncroachmentTypeContainerComponent,
    EncroachmentStatusContainerComponent,
    DivestmentStatusContainerComponent,
    FilterReferencePipe,
    TitleComponent,
    TitleContainerComponent,
    DocumentTypeContainerComponent,
    DocumentTypeComponent,
    BankComponent,
    BankContainerComponent,
    DivisionContainerComponent,
    DivisionComponent,
    ContinentComponent,
    ContinentContainerComponent,
    FileLocationContainerComponent,
    FileLocationComponent,
    GeoDatumComponent,
    GeoDatumContainerComponent,
    CountryContainerComponent,
    CountryComponent,
    StateComponent,
    StateContainerComponent,
    LgaContainerComponent,
    LgaComponent,
    CommunityComponent,
    CommunityContainerComponent,
    ApprovalLevelComponent,
    NumberofapprovalComponent,
    MeasureComponent,
    PurposeComponent,
    CurrencyComponent,
    BankingStatusComponent,
    LandUseStatusComponent,
    RightHeldComponent,
    MeasureContainerComponent,
    PurposeContainerComponent,
    CurrencyContainerComponent,
    BankingStatusContainerComponent,
    LandUseStatusContainerComponent,
    RightHeldContainerComponent,

    AppConfigurationComponent,
    AppConfigurationContainerComponent,

    CategoryComponent,
    CategoryContainerComponent,
    MeasuringFactorContainerComponent,
    MeasuringFactorComponent,
    CabinetshelfrefComponent,
    CabinetshelfrefContainerComponent,
    DocumentTypeCodeContainerComponent,
    DocumentTypeCodeComponent,
    RackettrayrefComponent,
    RackettrayrefContainerComponent,
    SecurityClassificationComponent,
    SecurityClassificationContainerComponent,

    PipelineLicenseCategoryComponent,
    PipelineLicenseStageComponent,
    PipelineLicenseStakeholderComponent,
    HierarchyComponent,
    HierarchyContainerComponent,
    PipelineLicenseStakeholderContainerComponent,
    PipelineLicenseStageContainerComponent,
    PipelineLicenseCategoryContainerComponent,
    StakeholderrepComponent,
    StakeholderrepContainerComponent,

    GroupComponent,
    GroupContainerComponent,
    AccountablefunctionContainerComponent,
    AccountablefunctionComponent,
    PaymentstatusComponent,
    PaymentstatusContainerComponent,
    OwnershiptypeComponent,
    OwnershiptypeContainerComponent,
    ClaimTypeComponent,
    TerrainComponent,
    SubsubgrouptypeComponent,
    SubsubgrouptypecategoryComponent,
    TerrainContainerComponent,
    ClaimTypeContainerComponent,
    SubsubgrouptypeContainerComponent,
    SubsubgrouptypecategoryContainerComponent,
    CompanyComponent,
    FunctionComponent,
    CompanyContainerComponent,
    CompanyFunctionComponent,
    CompanyFunctionContainerComponent,
    FunctionContainerComponent,
    DivestmentStatusComponent,
    EncroachmentStatusComponent,
    EncroachmentTypeComponent,
    EncroachmentTypeContainerComponent,
    EncroachmentStatusContainerComponent,
    DivestmentStatusContainerComponent,

    TitleComponent,
    TitleContainerComponent,
    BankComponent,
    BankContainerComponent,
    ContinentComponent,
    ContinentContainerComponent,
    FileLocationContainerComponent,
    FileLocationComponent,
    GeoDatumComponent,
    GeoDatumContainerComponent,
    CountryContainerComponent,
    CountryComponent,
    StateComponent,
    StateContainerComponent,
    LgaContainerComponent,
    LgaComponent,
    CommunityComponent,
    CommunityContainerComponent,

    MeasureComponent,
    PurposeComponent,
    CurrencyComponent,
    BankingStatusComponent,
    LandUseStatusComponent,
    RightHeldComponent,
    MeasureContainerComponent,
    PurposeContainerComponent,
    CurrencyContainerComponent,
    BankingStatusContainerComponent,
    LandUseStatusContainerComponent,
    RightHeldContainerComponent,

    AppConfigurationComponent,
    AppConfigurationContainerComponent,

    CategoryComponent,
    CategoryContainerComponent,
    MeasuringFactorContainerComponent,
    MeasuringFactorComponent,
    DocumentTypeCodeContainerComponent,
    DocumentTypeCodeComponent,
    DocumentTypeCodeContainerComponent,
    SecurityClassificationComponent,
    SecurityClassificationContainerComponent,
    FilterReferencePipe,
    RequesttypeContainerComponent,
    RequesttypeComponent,
    CorrespondencecompanyContainerComponent,
    CorrespondencecompanyComponent,
    CorrespondenceteamComponent,
    CorrespondenceteamContainerComponent,
    AssetstatusComponent,
    AssetstatusContainerComponent,
    LandprefixComponent,
    LandprefixContainerComponent,
    LossOfUseItemsComponent,
    LossOfUseItemsContainerComponent,
    CorrespondenceactionpartyComponent,
    CorrespondenceactionpartyContainerComponent,

    //eGG COMPONENTS AND CONTAINERS
    AccessRightComponent,
    AccessRightContainerComponent,
    CofOStatusComponent,
    CofOStatusContainerComponent,
    CounselTypeComponent,
    CounselTypeContainerComponent,
    DamageStatusComponent,
    DamageStatusContainerComponent,
    IncidentSubCategoryContainerComponent,
    IncidentSubCategoryComponent,
    IncidentQuantumComponent,
    IncidentQuantumContainerComponent,
    LicenceStatusComponent,
    LicenceStatusContainerComponent,
    LessorRepTypeComponent,
    LessorRepTypeContainerComponent,
    QuantumComponent,
    QuantumContainerComponent,
    PoleComponent,
    PoleContainerComponent,
    RateStatusComponent,
    RateStatusContainerComponent,
    YearOfSuitContainerComponent,
    YearOfSuitComponent,
    DocumentCategoryContainerComponent,
    DocumentCategoryComponent,
    StakeholderrepContainerComponent,
    StakeholderrepComponent,

    //MFON
    ObligationPeriodComponent,
    ObligationPeriodContainerComponent,
    RequestSubCategoryComponent,
    RequestSubCategoryContainerComponent,
    RackTrayRefComponent,
    RackTrayRefContainerComponent,
    SubGroupComponent,
    SubGroupContainerComponent,
    SubSubGroupComponent,
    SubSubGroupContainerComponent,
    PipelinegradeContainerComponent,
    PipelinegradeComponent,
    PipelineassetlocationContainerComponent,
    PipelineAssetLocationComponent,

    //BLESSED
    DocumentTypeComponent,
    DocumentTypeContainerComponent,
    DeliveryTypeContainerComponent,
    DeliveryTypeComponent,
    DamageListContainerComponent,
    DamageListComponent,
    CleanUpStatusContainerComponent,
    CleanUpStatusComponent,
    CabinetShelfRefContainerComponent,
    CabinetShelfRefComponent,
    BatchContainerComponent,
    BatchComponent,
    AddressTypeTblContainerComponent,
    AddressTypeTblComponent,
    ActivityStatusContainerComponent,
    ActivityStatusComponent,
    AcquisitiontypeContainerComponent,
    AcquisitiontypeComponent,

    //MADAM J
    ExpirationStatusComponent,
    ExpirationStatusContainerComponent,
    FacilityAssetComponent,
    FacilityAssetContainerComponent,
    IncidentCategoryComponent,
    IncidentCategoryContainerComponent,
    IPStatusComponent,
    IPStatusContainerComponent,
    IssuedCategoryComponent,
    IssuedCategoryContainerComponent,
    ItemTypeComponent,
    ItemTypeContainerComponent,
    LorpContainerComponent,
    LorpComponent,
    NetworkComponent,
    NetworkContainerComponent,
    LeaseExpirationContainerComponent,
    LeaseExpirationComponent,
    PartyContainerComponent,
    PartyComponent,

    //SEISMIC
    SeismicClaimTypeComponent,
    SeismicCommunityComponent,
    SeismicCrewComponent,
    SeismicClaimTypeContainerComponent,
    SeismicCommunityContainerComponent,
    SeismicCrewContainerComponent,
    SeismicDamageListContainerComponent,
    SeismicDivisionContainerComponent,
    SeismicPartyContainerComponent,
    SeismicSwathNoContainerComponent,
    SeismicDamageListComponent,
    SeismicDivisionComponent,
    SeismicPartyComponent,
    SeismicSwathNoComponent,
    SeismicCurrencyContainerComponent,
    SeismicCurrencyComponent,
    SeismicLineTypeContainerComponent,
    SeismicLineTypeComponent,
    SeismicProgramContainerComponent,
    SeismicProgramComponent,
    SeismicOMLContainerComponent,
    SeismicOMLComponent,
    IncidenteventtypeContainerComponent,
    IncidentriskareaContainerComponent,
    IncidenttabsContainerComponent,
    IncidenttabsineventContainerComponent,
    IncidentEventTypeComponent,
    IncidentRiskAreaComponent,
    IncidentTabsComponent,
    IncidentTabsInEventComponent,
    IncidentaboutContainerComponent,
    IncidentownersmappingContainerComponent,
    IncidentAboutComponent,
    IncidentOwnersMappingComponent,
    ReportReferenceComponent,
    // AppConfigContainerComponent,
    // AppConfigComponent,

  ],
  providers: [
    CountryFacade,
    StateFacade,
    LgaFacade,
    ScholarshipTypeFacade,
    ScholarshipCategoryFacade,
    ScholarshipSessionFacade,
    ScholarshipAwardDurationFacade,
    CommunityFacade,
    CourseOfStudyFacade,
    GenderFacade,
    EpimsBankFacade,
    EpimsBankDetailFacade,
    CurrencyFacade,
    ProjectCategoryFacade,
    ProjectTypeFacade,
    ClusterFacade,
    ClusterCommunityFacade,
    OilBlockFacade,
    OilFieldFacade,
    DocumentCategoryFacade,
    DocumentSubCategoryFacade,
    CorrespondenceActionPartyFacade,
    CorrespondenceCompanyFacade,
    CorrespondenceTeamFacade,
    CorrespondenceFunctionFacade,
    CorrespondenceRequestCategoryFacade,
    CorrespondenceIssuedCategoryFacade,
  ],
  exports: [EpimsReferenceSpinnerComponent],
  entryComponents: [],
})

export class EpimsReferencesModule {}
